import React, { createContext, useContext } from 'react';

export const UnreadNotesContext = createContext(null);

export const useUnreadNotes = () => {
  const context = useContext(UnreadNotesContext);
  if (!context) {
    // Return a no-op function if context is not available (prevents errors during initial render)
    return { refreshUnreadCount: 0, triggerRefresh: () => {} };
  }
  return context;
};
